import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {reaction, autorun} from 'mobx';
import StateDropdown from './stateDropdown';
import Cookies from 'js-cookie';
import * as moment from 'moment';
import Lottie from 'react-lottie';
import * as animationData from '../static-json/loading.json';

@inject ('RootStore')
@observer class RulesApp extends Component {


  //General Constructor Function
  constructor(props) {
    super(props);
    this.initialVal = this.props.RootStore.globalPropsStore.wizardProps.wizardStateValue;
    this.state = {isStopped: false, isPaused: false};
    autorun(() => {
      const {RootStore} = this.props;
      if(RootStore.globalPropsStore.wizardProps.wizardStateValue != this.initialVal){
        RootStore.globalPropsStore.getAllWizardResults();
      }
      console.log(initialVal);
    });
  }

  //Render Function
  render() {
    //Pull the root store from application props
    const {RootStore} = this.props;

    //Scope of this for closures
    const _this = this;

    //Lottie settings as a ...
    const lottieOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    //Return all
    return (
      <>
        <div className="rules-app-container">
          <StateDropdown class="inline"/>
        </div>
        { RootStore.globalPropsStore.wizardProps.isLoading &&
          <>
            { !RootStore.globalPropsStore.wizardProps.isInit &&
              <div className="rules-loader">
                <Lottie options={lottieOptions}
                    height={300}
                    width={300}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}/>
              </div>
            }
          </>
        }
        {!RootStore.globalPropsStore.wizardProps.isLoading &&
          <div className="article__container article__container--inset">
            <div className="article__content">
              <hr/>
              <div className="content__left">
                <h4>Important Dates</h4>
              </div>
              <div className="content__right">
                <p>Here are the key dates to be aware of as a voter in {RootStore.globalPropsStore.wizardProps.wizardStateName}</p>
                <ul className="election-list">
                {RootStore.globalPropsStore.electionResults.map((election, index) => (
                  <li key={index}>
                    <span className="election-list__title">{election.name}</span>
                    <span className="election-list__date">{moment(election.election_day).format('MMM D')}</span>
                  </li>
                ))}
                </ul>
              </div>
            </div>
            <div className="article__content">
              <hr/>
              <div className="content__left">
                <h4>Early Voting</h4>
              </div>
              {RootStore.globalPropsStore.wizardProps.earlyVoting &&
                <div className="content__right">
                  <p>Early voting in {RootStore.globalPropsStore.wizardProps.wizardStateName} is allowed! Each state sets its own rules about how you can cast your ballot ahead of Election Day, so read up on how you can do so in {RootStore.globalPropsStore.wizardProps.wizardStateName}.</p>
                  <p><a target="_blank" href={`https://www.vote.org/state/` + RootStore.globalPropsStore.wizardProps.wizardStateName.toLowerCase().replace(' ', '-')}>Find {RootStore.globalPropsStore.wizardProps.wizardStateName}'s voting details here</a></p>
                </div>
              }
              {!RootStore.globalPropsStore.wizardProps.earlyVoting &&
                <div className="content__right">
                  <p>{RootStore.globalPropsStore.wizardProps.wizardStateName} does not have early voting. You may look into absentee voting as an alternative to going to the polls on Election Day.</p>
                  <p><a href="/learn_articles/how-do-i-vote-by-mail/">Read more about Absentee Voting here</a></p>
                </div>
              }
            </div>
            <div className="article__content">
              <hr/>
              <div className="content__left">
                <h4>ID Requirements</h4>
              </div>
              <div className="content__right">
                <p>Each state requires different kinds of ID at the polls — there is no federal rule.</p>
                <p><a href="/learn_articles/do-i-need-an-id/">Read more about ID Requirements here</a></p>
                <p><a target="_blank" href={`https://www.vote.org/state/` + RootStore.globalPropsStore.wizardProps.wizardStateName.toLowerCase().replace(' ', '-')}>Find your requirements here</a></p>
              </div>
            </div>
          </div>
        }
      </>
    );
  }

}

export default RulesApp;
